import { render } from "./appPaperCenter.vue?vue&type=template&id=acf776a0&scoped=true"
import script from "./appPaperCenter.vue?vue&type=script&lang=js"
export * from "./appPaperCenter.vue?vue&type=script&lang=js"

import "./appPaperCenter.vue?vue&type=style&index=0&id=acf776a0&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acf776a0"]])

export default __exports__